import { createFileRoute } from '@tanstack/react-router'
import OportunidadesKanbanPage from '@/pages/oportunidades/oportunidades-kanban-page'
import { ProtectedRoute } from '@/components/auth'
import { CAPABILITIES } from '@/constants/capabilities'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/oportunidades/$funilValue',
)({
  component: function OportunidadesKanbanRoute() {
    const { dashboardId, funilValue } = Route.useParams()
    return (
      <ProtectedRoute
        anyOf={[CAPABILITIES.CRM_ALL, CAPABILITIES.CRM_OWN]}
        dashboardId={dashboardId}
      >
        <OportunidadesKanbanPage
          dashboardId={dashboardId}
          funilValue={funilValue}
        />
      </ProtectedRoute>
    )
  },
})
